

// import { clientResolver } from './shared/resolvers/client-resolver';

// const ListaClients = () => import("@/app/views/clientes/client-list/ListaClients");

const MyProducts = () => import('@/app/views/clientes/views/client-plans/ClientProducts');
const MyProductsDetail = () => import('@/app/views/clientes/views/client-plans/ClientProductDetail');

const MyStayings = () => import('@/app/views/clientes/views/client-staying/ClientStaying');
const MyStayingsDetail = () => import('@/app/views/clientes/views/client-staying/ClientStayingDetail');
const Loyalty = () => import('@/app/views/clientes/views/client-loyalty/ClientLoyalty');

const clientRoutes = [
  {
    path: "gestion",
    redirect: "/gestion/estacionamientos",
    name: "Gestión",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [

      {
        path: "estacionamientos",
        redirect: "/gestion/estacionamientos",
        name: "Mis Estacionamientos",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "Listado",
            component: MyStayings,
            meta: {
              auth: true
            }
          },
          {
            path: '/gestion/estacionamientos',
            name: '',
            component: MyStayingsDetail,
            meta: {
              auth: true
            },
            children:[
              {
                path: '/gestion/estacionamientos/:id',
                name: 'Detalle',
                meta: {
                  auth: true
                }
              }
            ]
          }
        ]
      },

      {
        path: "contrataciones",
        redirect: "/gestion/contrataciones",
        name: "Mis Planes",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "Listado",
            component: MyProducts,
            meta: {
              auth: true
            }
          },
          {
            path: "/gestion/contrataciones",
            name: '',
            component: MyProductsDetail,
            meta: {
              auth: true
            },
            children: [
              {
                path: '/gestion/contrataciones/:id',
                name: 'Detalle',
                meta: {
                  auth: true
                }
              }
            ]
          },
        ]
      },

      {
        path: "/gestion/fidelizacion",
        name: 'Fidelización',
        component: Loyalty,
        meta: {
          auth: true
        }
      }

      // {
      //   path: "pagos",
      //   redirect: "/gestion/pagos",
      //   name: "Pagos",
      //   component: {
      //     render(c) {
      //       return c("router-view");
      //     }
      //   },
      //   children: [
      //     {
      //       path: "",
      //       name: "Listado",
      //       component: ListaPagos,
      //       meta: {
      //         auth: true
      //       }
      //     },
      //     {
      //       path: "/gestion/pagos",
      //       name: '',
      //       component: DetallePago,
      //       meta: {
      //         auth: true
      //       },
      //       children: [
      //         {
      //           path: '/gestion/pagos/:id',
      //           name: 'Detalle',
      //           meta: {
      //             auth: true
      //           }
      //         }
      //       ]
      //     },
      //   ]
      // },





    ]
  },








]


export default clientRoutes;
